import React from 'react'
import UserAdminListContainer from '../../../component/users/organization-admin/user-admin-list/UserAdminListContainer'
 

function OrganizationAdmin() {
  return (
     <div className='page-body'>
     <UserAdminListContainer/>
     
    </div>
  )
}

export default OrganizationAdmin